module.exports = __webpack_public_path__ + "img/zahedi.80773eab.jpg";